// 3rd party
import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';

// Bernie
import { AnalyticsStore, ContextStore, ExperimentStore, PageStore } from 'bernie-plugin-mobx';

// Global Components
import { GlobalComponentsContextStore } from '@gc/global-controls-store';

// Stores
import {
  AccountDataStateStore,
  IndustryStore,
  LegalStore,
  LinkStore,
  ProductStore,
  ProductV2Store,
  ProgramStore,
  PzStore,
  PzCampaignStore,
  PzOAuthStore,
  QuicklinkStore,
  UiStore,
  UserStore,
  UserAuthStore,
  PartnerPerfStore,
  CountriesStore,
  UnsubscribeStore,
} from 'stores';

interface AffiliateHubStores {
  // Core
  analytics: AnalyticsStore;
  context: ContextStore;
  experiment: ExperimentStore;
  globalComponentsContext: GlobalComponentsContextStore;
  page: PageStore;

  // App
  accountDataStateStore: AccountDataStateStore;
  industries: IndustryStore;
  legal: LegalStore;
  link: LinkStore;
  products: ProductStore;
  productsV2: ProductV2Store;
  programs: ProgramStore;
  pzStore: PzStore;
  pzOAuthStore: PzOAuthStore;
  pzCampaignStore: PzCampaignStore;
  quicklinks: QuicklinkStore;
  uiStore: UiStore;
  user: UserStore;
  userAuth: UserAuthStore;
  partnerPerfStore: PartnerPerfStore;
  countriesStore: CountriesStore;
  unsubscribeStore: UnsubscribeStore;
}

function useStores() {
  return React.useContext(MobXProviderContext) as AffiliateHubStores;
}

export { useStores };
